<div id="yandex_rtb_R-A-9462968-1" *ngIf="!isDevMode() && environment.showAds" class="sticky-block"></div>
<div *ngIf="isDevMode() || !environment.showAds" class="bg-opacity-50 bg-black sticky-block" style="width: 300px; height: 300px">

</div>
